export const supplierProductState = {
  supplierProductFormStatus: false,
  supplierProductIsEdit: false,
  supplierProductSelectedForEdit: null,
  ProductSearchFilterParams: null,
  IndustrialServiceSearchFilterParams: null,
  ElectronicDocumentSearchFilterParams: null,
  ConsultingServiceSearchFilterParams: null,
  ProductPageNumber: null,
  ProductItemsPerPage: null,
  ProductSelectedItem: null,
  ProductCurrentList: null,
  IndustrialServicePageNumber: null,
  IndustrialServiceItemsPerPage: null,
  IndustrialServiceSelectedItem: null,
  IndustrialServiceCurrentList: null,
  ElectronicDocumentPageNumber: null,
  ElectronicDocumentItemsPerPage: null,
  ElectronicDocumentSelectedItem: null,
  ElectronicDocumentCurrentList: null,
  ConsultingServicePageNumber: null,
  ConsultingServiceItemsPerPage: null,
  ConsultingServiceSelectedItem: null,
  ConsultingServiceCurrentList: null,
};
